import { Seo } from "@/components/Seo";
import { PageHero } from "@/components/PageHero";
import { ServicesList } from "@/components/services/ServicesList";

export default function Services() {
  return (
    <>
      <Seo
        title="Services"
        description="RKG NATURALS services: Export, Import, E-Commerce, Drop Shipping and Service Provider support."
        path="/services"
      />
      <div data-testid="services-page">
        <PageHero eyebrow="Services" title="Services" />
        <ServicesList />
      </div>
    </>
  );
}
